module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Battery-empty-2f1122c297c28539f4fdc6fb9813418c.svg";